import { keyframes, styled } from '@mui/material/styles'
import { Box, Divider, IconButton, Paper, Typography } from '@mui/material'
import { MEDIA, thinScrollbar } from '../../../../constants'

const fadeInEffect = `
    animation-name: fadeIn;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 1s;

    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
`

export const OuterWrapper = styled(Paper)(`
    padding: 0 12px;
    width: 100vw;
    height: 100vh;
    position:fixed;
    display:flex;
    flex-direction:column;
    top:0;
    left:0;
    z-index: 50;
    @media (max-width: ${MEDIA.lg}) {
        padding: 0 12px;
    }
    
    & .footerWrapper {
        height: 40px;
        background: transparent;
    }
`)

// Change it to theme base to use the scrollbar
export const AskIaLayoutOuterWrapper = styled(Paper)`
  height: 100%;
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  overflow-y: scroll;
  background: transparent;
  padding-top: 60px;
  scroll-behavior: smooth;
  padding-bottom: 140px;

  ${thinScrollbar.styles};
`;

// export const AskIaLayoutOuterWrapper = styled(Paper)(({ theme }) => ({
//   // NOTE: IN THE WRAPPER <AskIaLayout/> respective css is also written ..
//   height: '100%',
//   borderRadius: '24px',
//   display: 'flex',
//   flexDirection: 'column',
//   width: '100%',
//   position: 'relative',
//   overflowY: 'scroll',
//   background: 'transparent',
//   // background: theme.palette.background.secondary,
//   paddingTop: '60px',
//   scrollBehavior: 'smooth',
//   paddingBottom: '140px',

//   // border: '1px red solid',
//   // '&::scrollbar-button, &::-webkit-scrollbar-button': {
//   //   display: 'none',
//   // },
//   // '&::scrollbar, &::-webkit-scrollbar': {
//   //   width: '8px',
//   // },
//   // '&::scrollbar-track, &::-webkit-scrollbar-track': {
//   //   // backgroundColor: '#f0f0f0',
//   //   backgroundColor: 'transparent',
//   //   borderRadius: '4px',
//   // },
//   // '&::scrollbar-thumb, &::-webkit-scrollbar-thumb': {
//   //   backgroundColor: '#888',
//   //   borderRadius: '4px',
//   //   border: '2px solid #f0f0f0',
//   // },
//   // '&::scrollbar-thumb:hover, &::-webkit-scrollbar-thumb:hover': {
//   //   backgroundColor: '#555',
//   // },
//   // scrollbarWidth: 'thin',
//   // scrollbarColor: '#888 #f0f0f0',
  
// }))

export const AskIAWrapper = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: '52px',
  right: '28px',
  zIndex: 2,
}))

export const ChatOuterWrapper = styled(Box)(`
    display:flex;
    flex-direction:column;
    padding-top: 60px;
    position:relative;

    &.stopTypingLoader:before{
        content:'';
        position: fixed;
        top: 0;
        right: 0;
        width:100%;
        height:100%;
        background:rgba(255, 255, 255, 0.1);
        z-index:2;
    }
`)

export const ChatInnerWrapper = styled(Box)(`
    display:flex;
    flex-direction:column;

    & .answerWrap:last-child{padding-bottom:30px;}
`)

export const ServerChatWrapper = styled(Box)(`
    padding: 0px 32px;
    width:100%;
    display:flex;
    justify-content:start;
    gap: 10px;

    &.answerWrap:first-of-type .copyButton{
        display:none;
    }

    &.loaderWrapper{
        width:120px;
    }

    ${fadeInEffect}
`)

export const ServerContentWrapper = styled(Paper)(({ theme }) => ({
  position: 'relative',
  padding: '12px 16px',
  width: '100%',
  maxWidth: '100%',
  borderRadius: '12px 12px 12px 0px',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  boxShadow: 'none',
  backgroundColor: theme.palette.background.paper, // example of theme usage
  color: theme.palette.text.primary, // example of theme usage

  '&.loader': {
    paddingRight: '20px',
  },
  '& p': {
    paddingBottom: '10px',
  },
  '& p:last-child': {
    paddingBottom: 0,
  },
  '& .typingDone.none': {
    display: 'none',
  },
  '& .animationHide': {
    display: 'none',
  },
  '@keyframes animationfadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  '& .animationfadeIn': {
    opacity: 0,
    animation: 'animationfadeIn 1s ease-in-out forwards',
  },
  '& .htmlContent.hidden': {
    display:'none !important',
  },
  '& .htmlContent': {
    color: theme.palette.text.primaryTemp,
    ol: {
      marginLeft: '15px',
    },
    li: {
      color: theme.palette.text.primaryTemp,
    },
    'ul li': {
      listStyle : 'none',
      position : 'relative',
      paddingLeft: '14px',
      marginBottom : '5px'
    },
    'ul li::before': {
      content: '"\\003E"', // '>' character in unicode
      position: 'absolute',
      left: 0,
      top: 0,
      fontSize: '16px',
      color: theme.palette.mode === 'dark' ? '#FF8C01' : '#095BBD',
    },
    'li.level1::before': {
      content: '"\\003E"', // '>' character in unicode
      position: 'absolute',
      left: 0,
      top: 0,
      fontSize: '16px',
      color: theme.palette.mode === 'dark' ? '#FF8C01' : '#095BBD',
    },
    'li.level1': {
      marginBottom: '5px',
      listStyle: 'none',
      position: 'relative',
      paddingLeft: '14px',
    },
    'li.level2::before': {
      content: '""',
      position: 'absolute',
      left: '13px',
      top: '7px',
      width: '4px',
      height: '4px',
      borderRadius: '5px',
      backgroundColor: theme.palette.mode === 'dark' ? '#5B92D3' : '#686867',
    },
    'li.level2': {
      marginBottom: '5px',
      listStyle: 'none',
      position: 'relative',
      paddingLeft: '26px',
    },
    'table': {
      border: '1px solid ' + (theme.palette.mode === 'dark' ? '#454545' : '#E4E7EC'),
      borderRadius: '8px',
      borderSpacing: 0,
      width: '100%',
      marginBottom: '16px',
      borderCollapse: 'collapse',
      tableLayout: 'fixed',

      '& th': {
        textAlign: 'left',
        padding: '8px 16px',
        fontWeight: 600,
        color: theme.palette.text.primaryTemp,
      },
      '& td': {
        borderTop: '1px solid ' + (theme.palette.mode === 'dark' ? '#454545' : '#E4E7EC'),
        textAlign: 'left',
        padding: '8px 16px',
        color: theme.palette.text.primaryTemp,
      },
      
      '&:has(thead tr > *:nth-child(2)):not(:has(thead tr > *:nth-child(3))) th': {width: '50%'},
      '&:has(thead tr > *:nth-child(3)):not(:has(thead tr > *:nth-child(4))) th': {width: '33.3333%'},
      '&:has(thead tr > *:nth-child(4)):not(:has(thead tr > *:nth-child(5))) th': {width: '25%'},
      '&:has(thead tr > *:nth-child(5)):not(:has(thead tr > *:nth-child(6))) th': {width: '20%'},
      '&:has(thead tr > *:nth-child(6)):not(:has(thead tr > *:nth-child(7))) th': {width: '16.6667%'},
      '&:has(thead tr > *:nth-child(7)):not(:has(thead tr > *:nth-child(8))) th': {width: '14.2857%'},
      '&:has(thead tr > *:nth-child(8)):not(:has(thead tr > *:nth-child(9))) th': {width: '12.5%'},
      '&:has(thead tr > *:nth-child(9)):not(:has(thead tr > *:nth-child(10))) th': {width: '11.1111%'},

    },
    b: {
      fontWeight: 600,
      color: theme.palette.text.primaryTemp,
    },
    strong: {
      fontWeight: 600,
      color: theme.palette.text.primaryTemp,
    },
    p: {
      paddingBottom: '5px',
      color: theme.palette.text.primaryTemp,
    },
    h1: {
      fontWeight: 500,
      fontSize: '19px',
      paddingBottom: '10px',
      color: theme.palette.text.primaryTemp,
    },
    h2: {
      fontWeight: 500,
      fontSize: '17px',
      paddingBottom: '5px',
      paddingTop: '10px',
      color: theme.palette.text.primaryTemp,
    },
    h3: {
      fontWeight: 500,
      fontSize: '15px',
      paddingBottom: '10px',
      color: theme.palette.text.primaryTemp,
    },
    span: {
      color: theme.palette.text.primaryTemp,
    },
  },
}))

export const RawData = styled(Box)(`
    display:none;
`)

export const ClientChatWrapper = styled(Box)(`
    padding: 0px 32px;
    width:100%;
    display:flex;
    gap: 10px;
    margin-bottom: 16px;

    @-moz-document url-prefix() {
        padding-right:15px;
    }
    
    & .question-content {
        width: auto;

        p {
          font-size : 14px;
        }
    }

    ${fadeInEffect}
`)

export const ClientContentWrapper = styled(Paper)(({ theme }) => ({
  padding: '12px 16px',
  width: '100%',
  boxShadow: 'none',
  borderRadius: '0px 12px 12px 12px',
  color: theme.palette.text.primaryTemp,
  '& p': {
    paddingBottom: '10px',
    fontWeight: 400,
    fontSize: '16px',
  },
  '& > *:last-child': {
    paddingBottom: 0,
  },
}))

export const SearchBoxOuterWrapper = styled(Box)(`
    width:100%;
    display:flex;
    flex-direction:column;
    align-items: center;
`)

export const IADisclaimer = styled(Typography)(({ theme }) => ({
  margin: '10px auto',
  fontSize: '13px',
  color: theme.palette.mode === 'dark' ? '#636B73' : '#686867',
}))

export const SearchWrapper = styled(Box)(({ theme }) => ({
  // width: 'calc(100% - 100px)',
  width: 'calc(100vw - 90px)',
  position: 'fixed',
  bottom: '35px',
  display: 'flex',
  flexDirection: 'column',
  left: '44px',
  right: '44px',
  background: theme.palette.background.secondary,
  [theme.breakpoints.down(MEDIA.lg2)]: {
    width: 'calc(100% - 88px)',
  },
}))

export const SearchInputBox = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: '68px',
  borderRadius: '34px',
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  position: 'relative',
  padding: '10px 0px',
  background: theme.palette.input.background,
  border: `1px solid ${theme.palette.mode === 'light' ? 'rgba(149, 161, 172, 1)' : '#000'}`,
  '&.input-focus': {
    border: `1px solid ${theme.palette.mode === 'light' ? '#000' : 'rgba(167, 177, 186, 1)'}`,
  },
  '& .MuiOutlinedInput-root': {
    padding: 0,
  },
  '& textarea': {
    width: '100%',
    fontSize: '16px !important',
    background: theme.palette.input.background,
    color: theme.palette.input.text,
    padding: '0 60px',
  },
  '& textarea::placeholder': {
    fontSize: '16px !important',
    color: theme.palette.input.placeholder,
  },
  '& textarea.Mui-disabled': {
    color: '#1c819e',
    '-webkit-text-fill-color': theme.palette.input.text,
  },
  '& fieldset': {
    border: '0 !important',
  },
  '& *': {
    borderBottom: 0,
  },
  '& .icon-question-round': {
    position: 'absolute',
    top: '50%',
    left: '26px',
    transform: 'translateY(-50%)',
    width: '20px',
    height: '20px',
  },
  '& .send-button': {
    background: '#000',
    position: 'absolute',
    right: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    '&:disabled': {
      background: theme.palette.mode === 'dark' ? '#1D2023' : '#EFEFEF',
    },
  },
  '& .input-wrapper-new': {
    width: '100%',
  },
}))

export const SearchSubmit = styled(Box)(`
    width: 22px;
    height: 22px;
    display:block;
    background: #095BBD;
    border: 1px #E4E7EC solid;
    border:0;
    border-radius:50%;
    position:absolute;
    bottom:22px;
    right:5px;
    z-index:1;
    overflow:hidden;
    
    &:before {
        content: '';
        border: 6px transparent solid;
        border-left-color: #fff;
        position: absolute;
        top: 5px;
        left: 9px;
    }

    & button {
        width:100%;
        height:100%;
    }

    &.disabled {
        background: #d3d3d3;
    }
`)

export const LinksWrapper = styled(Box)(`
    opacity: 1;
    
    width:100%;
    display: flex;
    // flex-direction: column;
    align-items: flex-start;
    margin-right:20px;
    flex-wrap:wrap;

    &.show {
        opacity: 1;
        animation-name: slideDown;
        animation-iteration-count: 1;
        animation-timing-function: ease-in;
        animation-duration: 1s;
    }

    &.disable button {
        opacity: 0.6;
        cursor: default;
    }

    @keyframes slideDown {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    & h4 {
        padding-top:10px;
        padding-bottom:10px;
        font-size: 14px;
        line-height: 20px;
        width:100%;
    }

    & > button:hover {
        background:none;
    }
    & > button span{
        margin-left:5px;
    }
`)

export const ServerContentLoader = styled(Box)(`
    margin-top: -15px;

    &.load-3 .line:nth-last-of-type(1) { animation: loadingC 0.6s 0.1s linear infinite; }
    &.load-3 .line:nth-last-of-type(2) { animation: loadingC 0.6s 0.2s linear infinite; margin:0 3px; }
    &.load-3 .line:nth-last-of-type(3) { animation: loadingC 0.6s 0.3s linear infinite; }
  
    @keyframes loadingC {
        0 { transform: translate(0, 0); }
        50% { transform: translate(0, 15px); }
        100% { transform: translate(0, 0); }
    } 

    @keyframes loadingJ {
        0%, 100% { transform: translate(0, 0); }
        50% { transform: translate(80px, 0); background-color: #f5634a; width: 25px; }
    }
  
    & .line {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 10px;
        background-color: rgba(0,0,0,0.3);
    }
`)

export const IconCloseOuterWrapper = styled(Box)(`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    min-height: 40px;
    padding: 0 16px;
`)

export const Logo = styled(Box)(`
    display: flex;
    align-items: center;
    & img {
      height: 16px;
    }
  `)

export const HeaderLeftSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  '& .brand-name': {
    fontSize: '16px',
    fontWeight: 600,
    color: theme.palette.text.primaryTemp,
  },
  '& .project-type': {
    fontSize: '13px',
    fontWeight: 400,
    color: theme.palette.text.primaryTemp,
  },
  '& .sub-title': {
    color: theme.palette.success.main,
    fontSize: '14px',
    fontWeight: 600,
  },
}))

export const HeaderRightSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '& .button-back': {
    borderRadius: '4px',
    height: '28px',
    fontWeight: 400,
    background: 'transparent',
    color: theme.palette.mode === 'dark' ? '#7C868F' : '#000',
  },
}))

export const IconCloseWrapper = styled(Box)(`
    position: absolute;
    z-index:1;
    top: 10px;
    right: 15px;
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    cursor: pointer;
`)

export const IconButtonOuterWrapper = styled(Box)(`
    display:flex;
    width:100%;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px;
    width:100%;
    margin: 12px 0;
`)

export const IconButtonWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  '& .thanks': {
    marginRight: '8px',
    color: theme.palette.mode === 'dark' ? '#fff' : '#686867',
    fontSize: '12px',
  },
  '& .btnCopy': {
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    background: theme.palette.mode === 'dark' ? '#2A2A29' : '#fff',
    '&:hover': {
      background: theme.palette.mode === 'dark' ? '#2A2A29' : '#fff',
    },
  },
}))

export const AllIconButton = styled(IconButton)(`
    height:32px;
    width: 32px;
    border-radius: 32px;
    padding: 0;
    & span {
        display:block;
        overflow:hidden;
        width: 32px;
        padding: 0;
        height: 30px;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.01;
    }

    &.btnThumbsUp:before {
        content: 'Like';
    }

    &.btnThumbsDown:before {
        content: 'Dislike';
    }

    &.btnCopy:before {
        content: 'Copy';
    }

    &:before, &:after {
        content: '';
        position: absolute;
        top: -28px;
        left: 50%;
        z-index: 1;
        background: #000;
        color: #fff;
        border-radius: 4px;
        padding: 4px 8px;
        display: none;
        font-size: 12px;
        transform: translate(-50%, 0);
    }
    &:after{
        display:none;
    }
    &:hover:before{
        display:block;
    }
    &.copied:hover:before{
        display:none !important;
    }
    &.copied:after{
        content: 'Copied';
        display:block;
    }

    border-radius:5px;
`)

export const StopTypingOverlay = styled(Box)(`
    position: fixed;
    width:100vw;
    height:100vh;
    top: 0;
    left: 0;
    z-index: 3;
    background: rgba(255,255,255,0.1);
    display:none;
`)

export const StopTyping = styled(Box)(({ theme }) => ({
  // borderRadius: '4px',
  position: 'relative',
  background: theme.palette.mode === 'dark' ? '#1D2023' : '#7C868F',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  padding: '8px 16px 8px 8px',
  borderRadius: '100px',
  gap: '8px',
  cursor: 'pointer',
}))

const shapeChange = keyframes`
  0%, 11.11% {
    clip-path: circle(50%);
    background-color: #000;
    opacity: 1;
    transform: rotate(90deg);
  }
  11.12%, 22.22% {
    clip-path: inset(0);
    background-color: #000;
    opacity: 1;
    transform: rotate(180deg);
  }
  22.23%, 33.33% {
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    background-color: #000;
    opacity: 1;
    transform: rotate(0deg);
  }
  33.34%, 44.44% {
    clip-path: circle(50%);
    background-color: #000;
    opacity: 1;
    transform: rotate(90deg);
  }
  44.45%, 55.55% {
    clip-path: inset(0);
    background-color: #000;
    opacity: 1;
    transform: rotate(180deg);
  }
  55.56%, 66.66% {
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
    background-color: #000;
    opacity: 1;
    transform: rotate(0deg);
  }
  66.67%, 88.88% {
    opacity: 0;
  }
  100% {
    clip-path: circle(50%);
    background-color: #000;
    opacity: 1;
  }
`

export const LoadingAnimationWrapper = styled(Box)(({ theme }) => ({
  width: '36px',
  height: '36px',
  background: '#fff',
  borderRadius: '100px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& .shape': {
    width: '20px',
    height: '20px',
    backgroundColor: '#3498db',
    animation: `${shapeChange} 9s steps(1) infinite`,
    transform: 'rotate(0deg)',
    transition: 'clip-path 0.3s ease, background-color 0.3s ease, transform 0.3s ease',
  },
}))

export const LoaderInitiating = styled(Box)(`
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    padding: 9px 10px;
    position: fixed;
    bottom: 151px;
    left: 60px;
    background: #fff;
    border-radius: 8px;
    z-index: 10;
`)

export const DefaultSection = styled(Box)(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  '& .how-help': {
    fontSize: '28px',
    color: theme.palette.text.primaryTemp,
  },
  '& .hello-this': {
    fontSize: '16px',
    color: theme.palette.text.secondary,
    marginTop: '10px',
  },
}))

export const AnswerDevider = styled(Divider)(({ theme }) => ({
  margin: '32px',
}))
